import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Nav from '../components/Nav/Nav';
import Movie from '../components/Movie/Movie';
import MovieMain from '../components/Main/MovieMain';

const TvCategory = () => {
  const { tvSlug } = useParams();

  const tvList = [
    { title: 'Trending', slug: 'trending-tv-shows', fetch: 'tvTrending' },
    { title: 'Action & Adventure', slug: 'action-and-adventure', fetch: 'tvActionAndAdventure' },
    { title: 'Airing Today', slug: 'tv-shows-airing-today', fetch: 'tvAiringToday' },
    { title: 'Comedy', slug: 'comedy-tv-shows', fetch: 'tvComedy' },
    { title: 'Animation', slug: 'animation-tv-shows', fetch: 'tvAnimation' },
    { title: 'Crime', slug: 'crime-tv-shows', fetch: 'tvCrime' },
    { title: 'News', slug: 'news', fetch: 'tvNews' },
    { title: 'Documentaries', slug: 'tv-documentaries', fetch: 'tvDocumentary' },
    { title: 'Reality', slug: 'reality-tv-shows', fetch: 'tvReality' },
    { title: 'Trending', slug: 'trending-tv-shows', fetch: 'tvTrending' },
    { title: 'War & Politics', slug: 'war-and-politics', fetch: 'tvWarAndPolitics' },
    { title: 'On Air', slug: 'tv-shows-on-air', fetch: 'tvOnAir' },
    { title: 'Talk', slug: 'talk', fetch: 'tvTalk' },
    { title: 'Top Rated', slug: 'top-rated-tv-shows', fetch: 'tvTopRated' },
    { title: 'Popular', slug: 'popular-tv-shows', fetch: 'tvPopular' },
    { title: 'Sci-Fi & Fantasy', slug: 'sci-fi-and-fantasy', fetch: 'tvSciFiAndFantasy' },
    { title: 'Kids', slug: 'kids-tv-shows', fetch: 'tvKids' },
    { title: 'Family', slug: 'family-tv-shows', fetch: 'tvFamily' },
    { title: 'Soap', slug: 'soap', fetch: 'tvSoap' },
    { title: 'Western', slug: 'western-tv-shows', fetch: 'tvWestern' },
  ];

  const tvShow = tvList.filter((tv) => tvSlug === tv.slug);

  const { title, fetch } = tvShow[0];

  const fetchApi = useSelector((state) => state[`${fetch}`]);

  return (
    <>
      <Nav />
      <MovieMain />
      <div className="main-movie-section">
        <Movie fetchUrl={fetchApi} title={title} />
      </div>
    </>
  );
};

export default TvCategory;
